import { render } from "./BookDetail.vue?vue&type=template&id=12c1d67a&scoped=true"
import script from "./BookDetail.vue?vue&type=script&lang=js"
export * from "./BookDetail.vue?vue&type=script&lang=js"

import "./BookDetail.vue?vue&type=style&index=0&id=12c1d67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c1d67a"]])

export default __exports__